import React, { useCallback, useRef, useState } from 'react'
import { rem } from 'polished'
import SolidTrianglePointerIcon from 'LuxKit/Icons/solid/SolidTrianglePointerIcon'
import SocieteNotificationCard from './SocieteNotificationCard'
import useSocieteCampaignTargetTier from 'loyalty/hooks/useSocieteCampaignTargetTier'
import { useAppDispatch } from 'hooks/reduxHooks'
import updateEmployeeNotification from 'actions/businessTraveller/updateEmployeeNotification'
import { EMPLOYEE_NOTIFICATION_DISMISS_PAYLOAD } from 'businessTraveller/constants/employeeNotificationConstant'
import useClickOutside from 'hooks/useClickOutside'

interface Props {
  activeSocieteNotification: App.BusinessTraveller.SocieteNotificationType | null
}

function SocieteNotificationDropdown({ activeSocieteNotification }: Props) {
  // Dropdown only supports almost there and unlock notifications, completion notification is shown on a modal
  const isSupportedNotification = activeSocieteNotification === 'ALMOST_THERE' || activeSocieteNotification === 'UNLOCK'
  const [dismissedNotification, setDismissedNotification] = useState<App.BusinessTraveller.SocieteNotificationType | null>(null)
  const { targetTier } = useSocieteCampaignTargetTier()
  const dispatch = useAppDispatch()

  const containerRef = useRef<HTMLDivElement>(null)
  const isOpen = !!activeSocieteNotification && isSupportedNotification && dismissedNotification !== activeSocieteNotification

  const dismiss = useCallback(() => {
    if (!activeSocieteNotification) return
    setDismissedNotification(activeSocieteNotification)
    dispatch(updateEmployeeNotification(EMPLOYEE_NOTIFICATION_DISMISS_PAYLOAD[activeSocieteNotification]))
  }, [dispatch, activeSocieteNotification])

  useClickOutside(containerRef, dismiss, isOpen)

  if (!isOpen) return null

  return <div ref={containerRef} style={{ position: 'absolute', top: 'calc(100% + 9px)', right: '0', width: rem(375) }}>
    <SolidTrianglePointerIcon size="L" colour={`tier-${targetTier}`} style={{ position: 'absolute', top: `-${rem(18)}`, right: rem(32), zIndex: 1 }} />
    <SocieteNotificationCard notificationType={activeSocieteNotification} onDismiss={dismiss} />
  </div>
}

export default SocieteNotificationDropdown
